import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-notification-box',
  templateUrl: './notification-box.component.html',
  styleUrls: ['./notification-box.component.scss'],
})
export class NotificationBoxComponent implements OnInit {
  @Input() public open: boolean = true;
  @Input() public isAnimated: boolean = false;
  @Input() public badgeText: string = '';
  @Input() public headerTitle: string = '';
  @Input() public description: string = '';
  @Input() public boxClassName: string = '';
  @Input() public innerHtmlDescription: string = '';
  @Input() public hint: string = '';
  @Input() public innerHtmlHint: string = '';
  @Input() public iconImage: string = '';
  @Input() public iconClass: string = '';
  @Input() public type: 'outlined' | 'filled' | 'info' = 'outlined';

  @Output() public confirm: EventEmitter<void> = new EventEmitter<void>();

  constructor() {}

  ngOnInit() {}

  public onConfirm() {
    this.confirm.emit();
  }
}
